import "core-js/es/map";
import "core-js/es/set";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import getRem from "./static/js/rem";
import Bridge from "./static/js/Bridge";
import { setCookie, getCookie } from "./static/js/utils";
import vConsole from "vconsole";

if (["wangqc3"].includes(getCookie("uid"))) {
  new vConsole();
}

require("../src/setupProxy");
getRem(750, 375);

const init = (cb) => {
  const isCochat = navigator.userAgent.includes("cochat");
  if (isCochat) {
    Bridge.getInfo((res) => {
      res = res || "{}";
      if (typeof res === "string") {
        res = JSON.parse(res);
      }
      Object.keys(res).forEach((key) => {
        setCookie(key, res[key]);
      });
      setTimeout(() => {
        cb && cb();
      }, 300);
    });
    setTimeout(() => {
      cb && cb();
    }, 300);
  } else {
    setTimeout(() => {
      cb && cb();
    }, 300);
  }
};
init(() => {
  ReactDOM.render(<App />, document.getElementById("root"));
});
